import React from 'react'
import "./CustomInput.css"
function CustomInput({placeholder,onChange,value,type,name,inputState}) {
  
  return (
    <input
    placeholder={placeholder}
    className={inputState?"error_input_container":"input_container"}
    onChange={onChange}
    value={value}
    type={type}
    name={name}

    />
  )
}

export default CustomInput
